<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<!--
 * @Author: 安兵洋
 * @Date: 2023-3-31 16:10:24
 * @LastEditTime: 2023-04-07 09:33:56
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: 询比价滚动展示列表
 * @FilePath: \epec-ope\src\views\content\yirongtongShop\components\recommendUnit.vue
-->
<template>
  <el-dialog
    :visible="visible"
    :title="titleText"
    width="600px"
    destroy-on-close
    :before-close="close"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div class="body">
      <div class="left_item">
        <div class="left_box">
          <div class="title">
            <div class="company-row">
              {{ current.senderCompanyName }}
            </div>
            <span>{{ current.createTime }}</span>
          </div>
          <div class="content">
            <div class="row1">
              <span class="key">联系人：</span>
              <span class="value margin-r">{{ current.contacts }}</span>
              <span class="key">联系电话：</span>
              <span class="value">{{ current.mobile }}</span>
            </div>
            <div class="row2">
              <span class="key">内容详情：</span>
              <span class="value">{{ current.content }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-for="item in replyList" :key="item.id">
        <div class="right_item">
          <div class="right_box">
            <div class="title">
              <span>{{ item.createTime }}</span>
              <div class="company-row">
                <!-- <img :src="saleImg" class="img" /> -->
                {{ item.replyCompanyName }}
              </div>
            </div>
            <div class="content">
              <div class="row1">
                <span class="key">联系人：</span>
                <span class="value margin-r">{{ item.replyName }}</span>
                <span class="key">联系电话：</span>
                <span class="value">{{ item.mobile }}</span>
              </div>
              <div class="row2">
                <span class="key">内容详情：</span>
                <span class="value">{{ item.replyContent }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my_reply_box">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="我的回复" prop="replyContent">
          <el-input
            v-model="ruleForm.replyContent"
            type="textarea"
            :rows="3"
            maxlength="300"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="left-btn" @click="reset">重 置</el-button>
      <el-button
        type="primary"
        class="right-btn"
        :disabled="loading"
        @click="reply"
        >确 定</el-button
      >
      <!-- <div class="add_new" @click="addNew">发起新留言</div> -->
    </div>
  </el-dialog>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapMutations } from 'vuex';
import Api from '@/modules/projectA/api/home/index';
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    setVisible: {
      type: Function,
      default: () => {}
    },
    refresh: {
      type: Function,
      default: () => {}
    },
    current: {
      type: Object,
      default: () => {
        return {
          title: ''
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      replyFirstMemberId: 0,
      replyList: [],
      ruleForm: {
        replyContent: ''
      },
      rules: {
        replyContent: [
          { required: true, message: '请输入您的回复', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    titleText() {
      return `${this.current.title}`;
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.replyList = [];
        this.getReply();
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations,
    getReply() {
      Api.queryReplyList({ id: this.current.id }).then(res => {
        if (res.success) {
          this.replyList = res.data;
        }
      });
    },
    reply() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          Api.replyMessage({
            ...this.ruleForm,
            messageBoardId: this.current.id
          })
            .then(res => {
              this.loading = false;
              if (res.success) {
                this.$message.success({
                  message: '回复成功',
                  duration: 1000
                });
                this.$refs.ruleForm.resetFields();
                this.setVisible(false);
                this.refresh();
              } else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.ruleForm.resetFields();
    },
    close() {
      this.setVisible(false);
    },
    addNew() {}
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 12px 20px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Source Han Sans CN';
  font-style: normal;

  .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
  }
  .el-dialog__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #333;
  }
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  max-height: 520px;
  height: 520px;
  overflow: hidden;
}

::v-deep.el-form-item {
  margin-bottom: 10px;

  .el-input__count {
    background: #fff;
    height: 0px;
  }

  .el-form-item__error {
    padding-top: 0px;
  }
}

.body {
  height: 400px;
  overflow: auto;

  .left_item {
    width: 100%;
    margin-bottom: 10px;
    .left_box {
      width: 500px;
      min-height: 107px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      .title {
        width: 460px;
        margin-left: 20px;
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ededed;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #333333;

        .company-row {
          display: flex;
          align-items: center;
        }
        .img {
          height: 18px;
          width: 18px;
          margin-right: 10px;
        }
        span {
          font-weight: 400;
          color: #666666;
          font-size: 14px;
        }
      }

      .content {
        padding: 0 20px 20px 20px;
        .margin-r {
          margin-right: 30px;
        }
        .key {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-size: 14px;
          line-height: 14px;
          display: inline-block;
          color: #999999;
          margin-right: 4px;
          white-space: nowrap;
        }

        .value {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-size: 14px;
          line-height: 14px;
          display: inline-block;
          color: #333333;
        }

        .row1 {
          display: flex;
          margin: 13px 0px;
        }

        .row2 {
          display: flex;
        }
      }
    }
  }
  .right_item {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    .right_box {
      width: 500px;
      min-height: 107px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      .title {
        width: 460px;
        margin-left: 20px;
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ededed;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #333333;

        .company-row {
          display: flex;
          align-items: center;
        }
        .img {
          height: 18px;
          width: 18px;
          margin-right: 10px;
        }
        span {
          font-weight: 400;
          color: #666666;
          font-size: 14px;
        }
      }

      .content {
        padding: 0 20px 10px 20px;
        .margin-r {
          margin-right: 30px;
        }
        .key {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-size: 14px;
          line-height: 14px;
          display: inline-block;
          color: #999999;
          margin-right: 4px;
          white-space: nowrap;
        }

        .value {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-size: 14px;
          line-height: 14px;
          display: inline-block;
          color: #333333;
        }

        .row1 {
          display: flex;
          margin: 13px 0px;
        }

        .row2 {
          display: flex;
        }
      }
    }
  }
}

.my_reply_box {
  height: 110px;
  background: #ffffff;
  margin: 0 -20px;
  padding: 20px 20px 0 20px;
  filter: drop-shadow(0px -1px 1px rgba(120, 128, 162, 0.3));
}
.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  .left-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 30px;
    border-radius: 0px;
    margin-right: 20px;
    &:hover {
      color: #333;
    }
  }
  .right-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 30px;
    border-radius: 0px;
    background: #2587ff;

    &:hover {
      background: #126edf;
    }
  }
  .add_new {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #0064c8;
    cursor: pointer;
  }
}
</style>
